export default __webpack_public_path__ + "ac91e95a98f95dc3277e88ad4ab04da8.webp";